import type { FindPaymentsRequestParams } from '../model/find-payments-params';
import type { FindPaymentsResponse } from '../model/find-payments-response';

export interface PaymentsApi {
  findPayments: (
    params: FindPaymentsRequestParams
  ) => Promise<FindPaymentsResponse>;

  generateReport: (
    params: FindPaymentsRequestParams
  ) => Promise<{ reportId: string }>;
}

export const PAYMENTS_API_KEY = 'paymentsApi';
export { GatewayPaymentsApi } from './gateway/gateway-payments-api';
